import { extendTheme } from "@chakra-ui/react";

export const theme = extendTheme({
    components: {
        Button: {
            baseStyle: {
                background: 'orange',
                _hover: {
                    background: '#f19c00',
                    _disabled: {
                        background: 'orange.300'
                    }
                },
                _disabled: {
                    background: 'orange.300'
                }
            },
            variants: {
                base: {},
                secondary: {
                    background: 'var(--chakra-colors-gray-100)',
                    _hover: {
                        background: 'var(--chakra-colors-gray-200)'
                    }
                },
                outline: {
                    background: 'white',
                    borderColor: 'orange',
                },
            },
            defaultProps: {
                variant: 'base'
            }
        },
        Table: {
            baseStyle: {
                thead: {
                    background: 'orange'
                }
            }
        }
    }
})
